<script lang="ts" setup>

import feedbackBgAvif from '@shared/ui/images/feedback/bg.avif'
import feedbackBgWebp from '@shared/ui/images/feedback/bg.webp'
import { useCommonStore } from '@shared/model'
import { AppImage } from '@shared/ui/images'
import { AppLogoDomain } from '@shared/ui/logos'
import { LoaderBlockDomain } from '@shared/ui/loaders'
import { useFeedbackStore } from '@pages/feedback'

defineOptions({
  name: 'LayoutFeedback',
})

const commonStore = useCommonStore()
const feedbackStore = useFeedbackStore()
const ready = computed(() => !commonStore.isLoading && feedbackStore.isReady)
</script>

<template>
  <div class="cs-app-feedback">
    <AppImage
      class="cs-app-feedback__bg"
      :srcset="feedbackBgAvif"
      :src="feedbackBgWebp"
      alt="bg"
    />

    <div class="cs-app-feedback__logo">
      <AppLogoDomain color="inverse" />
    </div>

    <div :class="['cs-app-feedback__card', { done: feedbackStore.isDone }]">
      <template v-if="ready">
        <div class="cs-app-feedback__back">
          <slot name="back" />
        </div>

        <div class="cs-app-feedback__close">
          <slot name="close" />
        </div>
      </template>

      <div
        v-if="!feedbackStore.isDone"
        class="cs-app-feedback__header"
      >
        <slot name="header">
          <div class="cs-app-feedback__title cs-app-feedback__body-l btly-text-body-l">
            Lesson feedback
          </div>
        </slot>
      </div>

      <div :class="['cs-app-feedback__content', { done: feedbackStore.isDone }]">
        <slot
          v-if="ready"
        />
        <LoaderBlockDomain v-else />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@app/layouts/feedback.scss" />
